import { Actions,  createEffect, ofType} from "@ngrx/effects";
import { inject, Injectable } from "@angular/core";
import { of } from "rxjs";
import { catchError, map, mergeMap, tap, withLatestFrom } from "rxjs/operators";

import { PersistenceService } from '@services/persistence.service';
import { Store } from "@ngrx/store";
import { AppState } from "@store/app.state";
import { SettingsActions } from "@store/actions/settings.actions";
import { selectSettings } from "@store/selectors/settings.selector";
import { Settings, defaultSetting } from "@models/settings.model";

@Injectable()
export class SettingsEffects {
    private actions$ = inject(Actions);
    private store = inject(Store<AppState>);
    constructor(private persistenceService: PersistenceService) { }
    loadSettings$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SettingsActions.loadSettings),
            mergeMap(() =>
                this.persistenceService.loadSettings().then(
                    (settings: Settings| undefined) => {
                        if (settings) {
                            return SettingsActions.loadSettingsSuccess({ settings: settings });
                        }
                        else {
                            return SettingsActions.loadSettingsSuccess({ settings: defaultSetting });
                        }
                    }
                )
            ),
            catchError((error) => {
                console.error('Error loading settings:', error);
                return of(SettingsActions.loadSettingsFailure({ error: error }));
            })
        )
    );

    saveSettings$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SettingsActions.updateSettings),
            withLatestFrom(this.store.select(selectSettings)),
            tap(([action, settings]) => {
                this.persistenceService.saveSettings(settings);
            })
        ),
        { dispatch: false }
    )

}